import { render, staticRenderFns } from "./CustomerDistributorWisePieChart.vue?vue&type=template&id=bd686ce8"
import script from "./CustomerDistributorWisePieChart.vue?vue&type=script&lang=js"
export * from "./CustomerDistributorWisePieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports